import { Modal, Spinner } from "react-bootstrap";
import TabellaLista from "../../../../components/Tabella/TabellaLista";
import { ChipFilter, filtroMultiplo } from "../../../../components/Tabella/ChipFilter";
import { Fragment, useEffect, useMemo, useState } from "react";
import { useNavigate } from "react-router-dom";
import MyApiClient from "../../../../../api-client/MyApiClient";
import DEFAULT_USER from "../../../../../images/DEFAULT_USER.png";
import { dateTimeSort } from "../../../../components/Util/oders";

// Valori dei filtri a chip, come compaiono nella lista.
const STATO_OPTIONS = ['Attivo', 'Completato', 'Inattivo'];

export const ListaJunior = () => {
    const navigate = useNavigate();

    const [data_json, setDataJson] = useState(null);
    // Chip a scelta multipla: all'inizio tutti accesi
    const [statoFilter, setStatoFilter] = useState(STATO_OPTIONS);

    const filteredData = useMemo(
        () => data_json && data_json.filter((row) => filtroMultiplo(statoFilter, STATO_OPTIONS, row.status?.label)),
        [data_json, statoFilter],
    );

    const [loadingShowed, setLoadingShowed] = useState(false);

    const data_column = [
        {
            Header: 'Data',
            Footer: 'Data',
            accessor: 'dateregistration',
            sortType: dateTimeSort,
            disableGlobalFilter: true,
        },
        {
            Header: 'Nome e Cognome',
            Footer: 'Nome e Cognome',
            accessor: 'name',
            Cell: ({ row }) => (
				<div style={{ display: 'flex', alignItems: 'center' }}>
                    <img
                        src={row.original.imageUrl ? row.original.imageUrl : DEFAULT_USER}
                        alt={row.original.name}
                        style={{
                        width: '40px',
                        height: '40px',
                        borderRadius: '50%',
                        marginRight: '10px'
                        }}
                    />
                    {row.original.name}
				</div>
			)
        },
        {
            Header: 'Parente',
			accessor: 'parentName',
			Cell: ({ row }) => (
				<div style={{ display: 'flex', alignItems: 'center' }}>
                    <img
                        src={row.original.imageUrlParent ? row.original.imageUrlParent : DEFAULT_USER}
                        alt={row.original.name}
                        style={{
                        width: '40px',
                        height: '40px',
                        borderRadius: '50%',
                        marginRight: '10px'
                        }}
                    />
                    {row.original.parentName}
				</div>
			)
        },
        {
            Header: 'Stato',
            Footer: 'Stato',
            id: 'status',
            accessor: row => row.status?.label,
            disableGlobalFilter: true,
            Cell: ({ row }) => {
                const { class: cls, label } = row.original.status || {};
                return (
                    <div className="d-flex align-items-center">
                        <i className={`fa fa-circle me-1 ${cls}`} />
                        {label}
                    </div>
                );
            },
        },
    ];

    function openDetail(row) {
		navigate('/superadmin/anagrafiche/junior/'+row.id);
	}

    useEffect(() => {
        const fetchData = async () => {
            try {
                const tokenDetailsString = sessionStorage.getItem('userDetails');
                if (tokenDetailsString) {
                    const tokenDetails = JSON.parse(tokenDetailsString);
                    let token = tokenDetails.idToken;
                    const apiClient = new MyApiClient();
            
                    setLoadingShowed(true);
                    const [membershipData] = await Promise.all([
                        apiClient.getProfilesByFilters(token,10000,null,'JUNIOR')
                    ]);
                    setLoadingShowed(false);
            
                    if(membershipData) {
                        let data_member = [];
                        membershipData.items.forEach(element => {
            
                            let image = null;
                            if(element.pictures && element.pictures[0] && element.pictures[0].uri) {
                                image = element.pictures[0].uri;
                            }

                            let imageParent = null;
                            if(element.parentPicture && element.parentPicture.uri) {
                                imageParent = element.parentPicture.uri;
                            }
            
                            let status = null;
                            if(element.profileStatus==='INACTIVE') {
                                status = {
                                    "label": "Inattivo",
                                    "class": "text-danger"
                                };
                            } else if(element.profileStatus==='ACTIVE') {
                                status = {
                                    "label": "Attivo",
                                    "class": "text-success"
                                };
                            } else if(element.profileStatus==='COMPLETED') {
                                status = {
                                    "label": "Completato",
                                    "class": "text-success"
                                };
                            }

                            const createdAt = element.createdAt;
							const data = new Date(createdAt);
							const options = { year: 'numeric', month: '2-digit', day: '2-digit', hour: '2-digit', minute: '2-digit', second: '2-digit' };
							const formattedDate = data.toLocaleDateString('it-IT', options);
            
                            let member_row = {
                                "id": element.userId,
                                "name": element.name,
                                "imageUrl": image,
                                "imageUrlParent": imageParent,
                                "status": status || { "label": ({ SUSPENDED: "Sospeso", INVITED: "Invitato" })[element.profileStatus || element.status] || element.profileStatus || element.status || "—", "class": "" }, // stato non previsto: si mostra invece di bloccare la lista
                                "email": "",
                                "dateregistration": formattedDate,
                                "parentName": element.parentName,
                            };
                            data_member.push(member_row);
            
                        });
                        setDataJson(data_member);
                    }
                }
            } catch (error) {
                console.error("Error fetching data:", error);
            }
        };
    
        fetchData();
    
    }, []);

    return (
        <>
            <Modal className="fade" show={loadingShowed} centered>
				<Modal.Body className="text-center">
				<Spinner animation="border" role="status">
					<span className="sr-only">Loading...</span>
				</Spinner>
				<div>Caricamento in corso...</div>
				</Modal.Body>
			</Modal>

            <Fragment>

                <TabellaLista
                    openColumn={'name'}
                    openRow={(row) => openDetail(row)}
                    cardTitle={'Junior'}
                    pageList={true}
                    hasSearch={true}
                    searchPlaceholder={'Cerca per nome o parente'}
                    hasFilter={false}
                    filterControl={
                        <div className="sid-chip-filters">
                            <ChipFilter label="Stato" options={STATO_OPTIONS} value={statoFilter} onChange={setStatoFilter} multiple />
                        </div>
                    }
                    hasAddMore={false}
                    data_column={data_column}
                    data_json={filteredData}
                    sort_by={'dateregistration'}
                    sort_type={'desc'}
                />

            </Fragment>
        </>
    )
}

export default ListaJunior